import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	board: {
		id: 'software-onboarding-modals.welcome-modal.wizards.right-hand-side.assets.board',
		defaultMessage: 'Board',
		description: 'Board tag on tab nav of svg in welcome wizards',
	},
	list: {
		id: 'software-onboarding-modals.welcome-modal.wizards.right-hand-side.assets.list',
		defaultMessage: 'List',
		description: 'List tag on tab nav of svg in welcome wizards',
	},
	timeline: {
		id: 'software-onboarding-modals.welcome-modal.wizards.right-hand-side.assets.timeline',
		defaultMessage: 'Timeline',
		description: 'Timeline tag on tab nav of svg in welcome wizards',
	},
	backlog: {
		id: 'software-onboarding-modals.welcome-modal.wizards.right-hand-side.assets.backlog',
		defaultMessage: 'Backlog',
		description: 'Backlog tag on tab nav of svg in welcome wizards',
	},
});
